import { isContainedInList } from "helpers/row-logic-helper";
import {
  PREPAYMENT_TYPES,
  AGGREGATE_INTEREST_METHODS
} from "@loanbossinc/component-library";

export const shouldShowTerm = (data, isQuote) => (data && data.isQuote !== undefined ? data.isQuote : isQuote);

export const shouldShowPercent = data => isContainedInList(data, "prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.FLAT_PERCENTAGE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE
]);
export const shouldShowOpenPeriod = data => isContainedInList(data, "prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.MAKE_WHOLE,
  PREPAYMENT_TYPES.DEFEASANCE,
  PREPAYMENT_TYPES.SPREAD_MAINTENANCE
]);
export const shouldShowForYmYmaMw = data => isContainedInList(data, "prepaymentTypeId", [
  PREPAYMENT_TYPES.YIELD_MAINTENANCE,
  PREPAYMENT_TYPES.YIELD_MAINTENANCE_AGENCY,
  PREPAYMENT_TYPES.MAKE_WHOLE
]);
export const shouldShowAggregateInterestMethodId = data => isContainedInList(data, "prepaymentTypeId", [
  PREPAYMENT_TYPES.AGGREGATE_INTEREST
]);
export const shouldShowAggregateInterestDefinedAmt = data => data &&
  data.aggregateInterestMethodId &&
  data.aggregateInterestMethodId === AGGREGATE_INTEREST_METHODS.DEFINED &&
  isContainedInList(data, "prepaymentTypeId", [
    PREPAYMENT_TYPES.AGGREGATE_INTEREST
  ]);
export const shouldShowAggregateInterestMonthsOfInterest = data => data &&
  data.aggregateInterestMethodId &&
  data.aggregateInterestMethodId === AGGREGATE_INTEREST_METHODS.FORMULAIC &&
  isContainedInList(data, "prepaymentTypeId", [
    PREPAYMENT_TYPES.AGGREGATE_INTEREST
  ]);
export const isSpreadMaintenance = data => isContainedInList(data, "prepaymentTypeId", [PREPAYMENT_TYPES.SPREAD_MAINTENANCE]);
export const shouldShowSMPVfields = data => isSpreadMaintenance(data) && data.shouldUsePV;

